module.exports = __webpack_public_path__ + "media/assets/images/dailyreport-bar-347eeec203c43265a7885dd2074ce375.svg";